'use strict';
import React from 'react';
import PropTypes from 'prop-types';

const PageContent = ({children, innerRef}) => <div className='page-content' ref={innerRef}>{children}</div>;

PageContent.propTypes = { children: PropTypes.node, innerRef: PropTypes.func };

export default PageContent;
